<script setup>
import { DocumentDuplicateIcon } from "@heroicons/vue/24/outline";
import { InformationCircleIcon } from "@heroicons/vue/24/solid";
import { ref, onMounted } from "vue";
import { getClientToken, refreshClientToken } from '@/services/settings';
const isComponentVisible = ref(true);
const clientToken = ref('');
const updatingToken = ref(false);
const updateSuccess = ref(false);
const copySuccess = ref(false);

const copyTokenToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(clientToken.value);
    copySuccess.value = true;
    setTimeout(() => (copySuccess.value = false), 2000);
  } catch (err) {
    console.error('Error al copiar el token:', err);
  }
};

async function handleRefreshToken(e) {
  e.preventDefault();
  updatingToken.value = true;
  updateSuccess.value = false;
  const clientId = localStorage.getItem('cx');
  if (clientId) {
    try {
      const { data } = await refreshClientToken(clientId);
      clientToken.value = data.token || '';
      updateSuccess.value = true;
      setTimeout(() => (updateSuccess.value = false), 2000);
    } catch (e) {
      // opcional: feedback de error
    } finally {
      updatingToken.value = false;
    }
  }
}
onMounted(async () => {
  const clientId = localStorage.getItem('cx');
  if (clientId) {
    try {
      const { data } = await getClientToken(clientId);
      clientToken.value = data.token || '';
    } catch (e) {
      clientToken.value = 'No disponible';
    }
  }
});
</script>
<template>
  <div style="background: white" v-if="isComponentVisible">
    <h5 class="create-title my-4">Generar Credenciales</h5>
    <article class="article">
      <h4>Acceso a Sevicios API de Golden Contactability</h4>
      <p>
        Usa cualquiera de nuestros servicios API para integrar tus datos con
        Golden Contactability.
      </p>
      <div class="d-flex flex-column gap-3 w-50 mt-4">
        <div class="order">
          <h5>Actualizar Token API</h5>
          <a class="a" href="" @click="handleRefreshToken">
            <span v-if="updatingToken">Actualizando...</span>
            <span v-else>ACTUALIZAR</span>
          </a>
          <span v-if="updateSuccess" style="color: #357A3B; font-weight: 600; margin-left: 1rem;">¡Token actualizado!</span>
        </div>
        <div class="order">
          <h5>
            Token API
            <div class="d-flex align-items-center gap-2">
              <span class="under"> {{ clientToken }} </span>
              <button class="copy-btn" @click="copyTokenToClipboard">
                <DocumentDuplicateIcon style="width: 20px; height: 20px" />
              </button>
            </div>
          </h5>
          <div class="d-flex align-items-center">
            <a class="a" href="" @click.prevent="copyTokenToClipboard"></a>
            <span v-if="copySuccess" style="color: #357A3B; font-weight: 600; margin-left: 1rem;">¡Copiado!</span>
          </div>
        </div>
      </div>
    </article>
    <!--article class="article">
      <h4>Acceso a Golden Contactability S3</h4>
      <p>
        Usa cualquier cliente de conexión a Amazon S3, como Cyberduck, para
        acceder a Golden Contactability S3 y subir tus archivos con la siguiente
        credencial.
      </p>
      <div class="d-flex flex-column gap-3 w-50 mt-4">
        <div class="order">
          <h5>Actualizar Credenciales GoldenContactability S3</h5>
          <a class="a" href="">ACTUALIZAR</a>
        </div>
        <div class="order">
          <h5>
            Bucket Name
            <div class="d-flex align-items-center gap-2">
              <span class="under"> s3://goldencontactability-clients/-- </span>
              <span
                ><DocumentDuplicateIcon
                  style="width: 20px; height: 20px"
                ></DocumentDuplicateIcon
              ></span>
            </div>
          </h5>
          <a class="a" href="">COPIAR</a>
        </div>
        <div class="order">
          <h5>
            Access Key ID
            <div class="d-flex align-items-center gap-2">
              <span class="under"> SKJDAMSAS1223DFDFDSF </span>
              <span
                ><DocumentDuplicateIcon
                  style="width: 20px; height: 20px"
                ></DocumentDuplicateIcon
              ></span>
            </div>
          </h5>
          <a class="a" href="">COPIAR</a>
        </div>
        <div class="order">
          <h5>
            Secure Access Key
            <div class="d-flex align-items-center gap-2">
              <span class="under"> SKJDAMSAS1223/kjsaAJSJKA29393mnnm </span>
              <span
                ><DocumentDuplicateIcon
                  style="width: 20px; height: 20px"
                ></DocumentDuplicateIcon
              ></span>
            </div>
          </h5>
          <a class="a" href="">COPIAR</a>
        </div>
      </div>
    </article>
    <div class="info">
      <div class="d-flex align-items-center gap-2 mb-1">
        <InformationCircleIcon
          style="width: 30px; height: 30px"
        ></InformationCircleIcon>
        <h4 class="m-0 mt-2">Información</h4>
      </div>
      <p class="m-0">
        Una vez hayas subido tus archivos, tu equipo podrá tener acceso a ellos
        en
        <span style="font-weight: 700">Menú &gt; Esquemas &gt; Subir Esquema</span>.
        Aparecerá un acceso directo a tus archivos con
        <span style="font-weight: 700">Golden Contactability S3</span>.
      </p>
    </div-->
  </div>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.a {
  color: $secondary-color;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    color: $five-color;
    transition: all ease-in-out 0.3s;
  }
}
.article {
  background-color: $fourth-color;
  border-radius: 15px;
  color: $primary-color;
  margin-bottom: 20px;
  margin-top: 20px;
  padding: 20px;
}
.under {
  display: block;
  color: $six-color;
  font-size: smaller;
  font-weight: 300;
  margin: 0;
}
.order {
  display: flex;
  justify-content: space-between;
}
.info {
  background-color: $primary-color;
  box-shadow: 0px 6px 10px $shadow-color;
  color: $white-color;
  border-radius: 15px;
  padding: 10px 20px;
}
.copy-btn {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    opacity: 0.8;
  }
}
</style>
